<template>
  <v-container class="ma-0 pa-0">
    <div v-if="!isLoading">
      <!-- Affichage du message d'erreur -->
      <card-alert
        v-if="hasError"
        :msg="errorMsg"
      />

      <!-- Affichage du message si aucune donnée -->
      <card-alert
        v-else-if="isEmpty"
        :msg="errorEmpty.msg"
        :icon="errorEmpty.icon"
        :color="errorEmpty.color"
      />
      <!-- Affichage du tableau -->
      <v-data-table
        v-else
        :headers="headers"
        :items="datas"
        :items-per-page="itemsPerPage"
        :dense="dense"
        :hide-default-footer="hideDefaultFooter"
        multi-sort
      />
    </div>
    <div v-else>
      <!-- Affichage du chargement -->
      <v-row justify="center">
        <circle10 />
      </v-row>
    </div>
  </v-container>
</template>

<script>
  /* Les composants et packages dont on a besoin */
  import CardAlert from '../../alerts/CardAlert.vue'
  import { Circle10 } from 'vue-loading-spinner'

  /* Rend le composant accessible aux autres composants */
  export default {
    /* Nom du composant */
    name: 'RegularTablesTemplate',

    /* Sous-composants utilisés par ce composant */
    components: {
      CardAlert,
      Circle10,
    },

    /* Paramètres */
    props: {
      headers: {
        type: Array,
        default: undefined,
      },
      datas: {
        type: Array,
        default: undefined,
      },
      isLoading: {
        type: Boolean,
        default: true,
      },
      hasError: {
        type: Boolean,
        default: false,
      },
      errorMsg: {
        type: String,
        default: '',
      },
      errorEmpty: {
        type: Object,
        default: function () {
          return {
            msg: 'Un problème est survenu.',
            icon: 'mdi-alert-rhombus-outline',
            color: 'error',
          }
        },
      },
      dense: {
        type: Boolean,
        default: false,
      },
      hideDefaultFooter: {
        type: Boolean,
        default: false,
      },
      itemsPerPage: {
        type: Number,
        default: 10,
      },
    },

    /* Variables internes dynamiques
     * (MAJ automatique quand les variables qu'elles utilisent sont mises à jour) */
    computed: {
      isEmpty: function () {
        return this.datas.length === 0
      },
    },
  }
</script>
